<template>
    <div class="col-12 row p-4 px-2 m-0 justify-content-around">
        <div class="col-12 card card-outline card-primary p-2" v-if="team">
            <div class="card-header">
                <h3 class="h3">{{ team.name }}</h3>
            </div>
            <div class="card-body">
                <form @submit.prevent="submit">
                    <div class="row p-2 m-0">
                        <div
                            class="col-12 row p-4 m-0 justify-content-center position-relative"
                        >
                            <div class="form-group col-10 col-md-5 col-lg-3">
                                <input
                                    type="file"
                                    ref="file"
                                    class="d-none"
                                    @change="changeFile"
                                />
                                <img
                                    class="image-responsive responsive col-12"
                                    :src="img"
                                />
                                <button
                                    class="field field-image btn btn-warning position-absolute text-white bottom-0 right-0"
                                    :error="errors.image"
                                    type="button"
                                    @click="
                                        () => {
                                            this.$refs.file.click();
                                        }
                                    "
                                >
                                    <i class="fa fa-upload"></i>
                                </button>
                            </div>
                        </div>
                        <div class="form-group col-12 col-md-6 col-lg-4">
                            <label>Nome do clube</label>
                            <input
                                required
                                @click="resetErrors"
                                type="text"
                                :error="errors.team"
                                v-model="team.name"
                                class="form-control field field-team"
                            />
                        </div>
                        <div class="form-group col-12 col-md-6 col-lg-4">
                            <label>Estado ou cidade</label>
                            <input
                                required
                                @click="resetErrors"
                                type="text"
                                :error="errors.location"
                                v-model="team.location"
                                class="form-control field field-location"
                            />
                        </div>
                        <div class="form-group col-12 col-md-6 col-lg-4">
                            <label>Nome do coordenador</label>
                            <input
                                type="text"
                                disabled
                                v-model="team.user.name"
                                class="form-control field field-name"
                            />
                        </div>
                        <div class="form-group col-12 col-md-6 col-lg-4">
                            <label>Fim da assinatura</label>
                            <input
                                type="date"
                                disabled
                                v-model="team.end_subscription"
                                class="form-control field field-end_subscription"
                            />
                        </div>

                        <div class="form-group col-12 col-md-6 col-lg-4">
                            <label>Número de usuários</label>
                            <input
                                type="number"
                                v-model="team.max_users"
                                disabled
                                class="form-control field field-max_users"
                            />
                        </div>
                        <div class="form-group col-12 col-md-6 col-lg-4">
                            <label>Limite de categorias</label>
                            <input
                                type="number"
                                v-model="team.max_categories"
                                disabled
                                class="form-control field field-max_categories"
                            />
                        </div>
                        <div class="form-group col-12 col-md-6 col-lg-4">
                            <label style="color: transparent !important"
                                >-</label
                            >
                            <button
                                type="submit"
                                class="form-control btn btn-primary"
                            >
                                {{ t("treinos.update") }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { t } from "@/lang";
import { mapMutations, mapActions } from "vuex";
import api from "@/utilities/Api.js";

export default {
    name: "NewTeamView",
    async created() {
        await this.getTeam();
    },
    data() {
        return {
            show: false,
            team: null,
            errors: {
                name: false,
                location: false,
                image: false,
            },
            img: null,
            defaultImage: null,
        };
    },
    methods: {
        t,
        ...mapMutations(["SET_LOADING"]),
        ...mapActions(["post", "get"]),
        async submit() {
            this.SET_LOADING(true);

            const formData = new FormData();
            for (let prop in this.team) {
                if (this.team[prop] != null) {
                    formData.append(prop, this.team[prop]);
                }
            }

            const res = await this.post({
                url: "team/",
                data: this.team,
                formData: formData,
            });
            if (res.status == 422) {
                alert(this.t("general.422"));
                for (let field in res.data.errors) {
                    this.errors[field] = true;
                    alert(res.data.errors[field][0]);
                }
            } else if (res.status >= 200 && res.status < 300) {
                alert(t("general.updated"));
                this.getTeam();
            } else {
                alert(res.data.message);
            }
            console.log(res);
            this.SET_LOADING(false);
        },
        resetErrors() {
            for (let err in this.errors) {
                this.errors[err] = false;
            }
        },
        async getTeam() {
            this.SET_LOADING(true);
            const res = await this.get({ url: "team" });
            if (res.status == 200) {
                this.team = res.data.team;
                this.defaultImage = `${api.url}images/teams/${this.team.image}`;
                this.team.image = null;
                this.img = this.defaultImage;
            }
            this.SET_LOADING(false);
        },
        changeFile(evt) {
            [this.team.image] = evt.target.files;
            if (this.team.image) {
                this.img = URL.createObjectURL(evt.target.files[0]);
            } else {
                this.img = this.defaultImage;
            }
        },
    },
};
</script>

<style scoped>
.form-control,
.btn {
    transition: all 0.4s ease-in-out;
}
[error="true"] {
    border: 1px solid red;
}
</style>
